import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/PALC_Full_Black.svg")